import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowDownUp } from '@mafc/icon';
import { Box } from '@mafc/trolly';

import { ISubstitutesShipment } from 'pages/NewCart/ISubstitutes.types';
import TrackerSubstitution from 'utils/Tracker.substitution';
import * as S from './ReplacementRow.style';

const ReplacementRow: React.FC<{
  forReplacementFound: boolean;
  substitutesShipment: ISubstitutesShipment;
  replaceBtnClickHandler?: () => void;
}> = ({ forReplacementFound, substitutesShipment, replaceBtnClickHandler }) => {
  useEffect(() => {
    if (forReplacementFound) {
      TrackerSubstitution.replacementAvailableTracking();
    }
  }, []);

  const { t } = useTranslation();
  return (
    <S.ReplaceRow>
      <Box>
        {forReplacementFound
          ? substitutesShipment.eligibleItems && substitutesShipment.eligibleItems.length > 1
            ? t('cartShipment.replacementAvailablePlural', {
                items: substitutesShipment.eligibleItems.length,
              })
            : t('cartShipment.replacementAvailableSingle')
          : substitutesShipment.nonEligibleItems && substitutesShipment.nonEligibleItems.length > 1
          ? t('cartShipment.replacementNotFoundPlural', {
              items: substitutesShipment.nonEligibleItems.length,
            })
          : t('cartShipment.replacementNotFoundSingle')}
      </Box>

      {forReplacementFound && (
        <S.ReplaceBtn variant="custom" onClick={replaceBtnClickHandler}>
          <S.ReplaceIcon>
            <ArrowDownUp />
          </S.ReplaceIcon>
          {t('cartShipment.replace')}
        </S.ReplaceBtn>
      )}
    </S.ReplaceRow>
  );
};

export default ReplacementRow;
